module.exports = __webpack_public_path__ + "img/member-team4.678d469f.jpg";